<template>
  <v-app>
    <!-- Simple Header -->
    <v-app-bar app color="white" elevation="1" height="60">
      <v-container class="d-flex align-center pa-0">
        <img src="../../assets/vastrosa-logo.png" alt="Vastrosa" height="40" />
        <v-spacer></v-spacer>
      </v-container>
    </v-app-bar>

    <v-main class="grey lighten-5">
      <v-container class="py-10" style="max-width: 550px">

        <!-- Success State -->
        <v-card v-if="submitted" rounded="xxl" elevation="6" class="pa-6 text-center">
          <v-icon color="success" size="80">mdi-check-circle</v-icon>
          <h2 class="mt-4 font-weight-bold">Request Submitted</h2>
          <p class="mt-3 grey--text text--darken-1">
            Your account deletion request has been received. Our team will review it shortly.
          </p>
          <p class="grey--text">
            You can close this page.
          </p>
        </v-card>

        <!-- Form -->
        <v-card v-else rounded="xxl" elevation="6">
          <v-card-title class="pa-6 pb-2">
            <v-icon color="error" class="mr-2">mdi-account-remove</v-icon>
            <span class="text-h6 font-weight-bold">Delete Account Request</span>
          </v-card-title>
          <v-card-subtitle class="px-6 pb-0">
            Fill in your details to submit a deletion request. Our admin team will review and process it.
          </v-card-subtitle>

          <v-card-text class="px-6 pt-4">
            <v-alert type="warning" text dense class="mb-4">
              This action is irreversible. Your account and all associated data will be permanently deleted.
            </v-alert>

            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="form.name"
                label="Full Name *"
                outlined
                rounded
                :rules="[rules.required]"
                prepend-inner-icon="mdi-account"
                class="mb-2"
              ></v-text-field>

              <v-text-field
                v-model="form.phone"
                label="Registered Phone Number *"
                outlined
                rounded
                :rules="[rules.required, rules.phone]"
                prepend-inner-icon="mdi-phone"
                type="tel"
                class="mb-2"
              ></v-text-field>

              <v-textarea
                v-model="form.reason"
                label="Reason for deletion (optional)"
                outlined
                rounded
                rows="3"
                prepend-inner-icon="mdi-text"
                counter="1000"
                class="mb-2"
              ></v-textarea>
            </v-form>
          </v-card-text>

          <v-card-actions class="px-6 pb-6">
            <v-btn
              block
              color="error"
              rounded
              large
              elevation="0"
              :loading="isLoading"
              :disabled="!valid"
              @click="submit"
            >
              <v-icon left>mdi-delete-forever</v-icon>
              Submit Deletion Request
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-container>
    </v-main>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" max-width="400">
      <v-card rounded="xxl">
        <v-container class="text-center pa-6">
          <v-icon color="error" size="70">mdi-alert-circle</v-icon>
          <h3 class="mt-3">{{ errorMessage }}</h3>
          <v-btn color="error" class="mt-4" @click="errorDialog = false">OK</v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  name: "AccountDeleteRequestCreate",
  data() {
    return {
      valid: false,
      isLoading: false,
      submitted: false,
      errorDialog: false,
      errorMessage: "",
      form: {
        name: "",
        phone: "",
        reason: "",
      },
      rules: {
        required: (v) => !!v || "This field is required.",
        phone: (v) => (v && v.length >= 10) || "Enter a valid phone number.",
      },
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;
      try {
        const response = await axios.post("/account-delete-requests/submit", {
          name: this.form.name,
          phone: this.form.phone,
          reason: this.form.reason,
        });

        if (response.data.success) {
          this.submitted = true;
        }
      } catch (error) {
        const msg = error.response?.data?.message || "Something went wrong. Please try again.";
        this.errorMessage = msg;
        this.errorDialog = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
